import { SALESDATA_PATH } from 'commons/constants/routes'
import { formatCurrencyCent } from 'commons/utils'
import { ButtonGroup, IconName, IconSize, Link, Tooltip } from 'ui/components'
import { TableButton } from 'ui/components/Buttons'
import { TableColumn } from 'ui/components/Table'
import { ResourcePath } from 'ui/temp/ResourcePath'

import { SalesSource } from '../../../../types'

import * as SC from './styles'

export const columns = (
  onTaskCancel: () => void,
  onTaskDelete: (id: number) => void,
  highRiskReviewId: number,
  licenseId: number
): TableColumn<SalesSource>[] => [
  {
    title: 'Source',
    sortable: false,
    align: 'left',
    width: '180px',
    render: ({ sourceId, sourceType }) => (
      <SC.WithIcons>
        <ResourcePath finishedPath={`${SALESDATA_PATH}/${sourceId}`} name={sourceType} id={sourceId} />
      </SC.WithIcons>
    )
  },
  {
    title: 'Total Sales',
    sortable: false,
    align: 'left',
    width: '160px',
    render: ({ totalSales, showAppliedTotalSales }) =>
      showAppliedTotalSales ? (
        <>
          <SC.DisabledPrice>{formatCurrencyCent(totalSales)}</SC.DisabledPrice>
          <br />({formatCurrencyCent(showAppliedTotalSales)})
        </>
      ) : (
        formatCurrencyCent(totalSales)
      )
  },
  {
    title: 'Cannabis Sales',
    sortable: false,
    align: 'left',
    width: '160px',
    render: ({ cannabisSales, showAppliedCannabisSales }) =>
      showAppliedCannabisSales ? (
        <>
          <SC.DisabledPrice>{formatCurrencyCent(cannabisSales)}</SC.DisabledPrice>
          <br />({formatCurrencyCent(showAppliedCannabisSales)})
        </>
      ) : (
        formatCurrencyCent(cannabisSales)
      )
  },
  {
    title: 'Non-Cannabis Sales',
    sortable: false,
    align: 'left',
    width: '160px',
    render: ({ nonCannabisSales, showAppliedNonCannabisSales }) =>
      showAppliedNonCannabisSales ? (
        <>
          <SC.DisabledPrice>{formatCurrencyCent(nonCannabisSales)}</SC.DisabledPrice>
          <br />({formatCurrencyCent(showAppliedNonCannabisSales)})
        </>
      ) : (
        formatCurrencyCent(nonCannabisSales)
      )
  },
  {
    title: 'Estimated Sales Tax',
    sortable: false,
    align: 'left',
    width: '160px',
    render: ({ taxes, showAppliedTaxes }) =>
      showAppliedTaxes ? (
        <>
          <SC.DisabledPrice>{formatCurrencyCent(taxes)}</SC.DisabledPrice>
          <br />({formatCurrencyCent(showAppliedTaxes)})
        </>
      ) : (
        formatCurrencyCent(taxes)
      )
  },
  {
    title: 'Status',
    key: 'status',
    sortable: false,
    align: 'left',
    width: '160px'
  },
  {
    title: '',
    sortable: false,
    align: 'left',
    render: ({ showDangerAlertNotes, showWarningAlertNotes }) => (
      <>
        {showDangerAlertNotes && (
          <SC.Alert>
            <SC.DangerAlertIcon name={IconName.ERROR} size={IconSize.S} /> {showDangerAlertNotes}
          </SC.Alert>
        )}
        {showWarningAlertNotes && (
          <SC.Alert>
            <SC.WarningAlertIcon name={IconName.INFO} size={IconSize.S} /> {showWarningAlertNotes}
          </SC.Alert>
        )}
      </>
    )
  },
  {
    title: '',
    sortable: false,
    align: 'right',
    width: '200px',
    render: ({ sourceId, approvalNeeded, enableEdit, showEditButtonTooltip, enableDelete, showEnableCancelTask }) => (
      <ButtonGroup margin="small">
        {approvalNeeded && (
          <Link to="/salesdata/$sourceId" params={{ sourceId: sourceId.toString() }}>
            <TableButton face="danger">View & Approve</TableButton>
          </Link>
        )}
        {!enableEdit && showEditButtonTooltip && (
          <Tooltip id="edit" type="dark" content={showEditButtonTooltip}>
            <TableButton face="neutral" disabled>
              Edit
            </TableButton>
          </Tooltip>
        )}
        {enableEdit && (
          <Link
            to="/salesdata/bank-source-override/$mrId/$licenseId"
            params={{ mrId: highRiskReviewId.toString(), licenseId: licenseId.toString() }}
            search={{ type: 'custom' }}
          >
            <TableButton face="positive">Edit</TableButton>
          </Link>
        )}
        {enableDelete && (
          <TableButton face="danger" onClick={() => onTaskDelete(sourceId)}>
            Delete
          </TableButton>
        )}
        {showEnableCancelTask && (
          <TableButton face="neutral" onClick={onTaskCancel}>
            Cancel Task
          </TableButton>
        )}
      </ButtonGroup>
    )
  }
]
